<template>
  <div class="tabulka" :class="TableWidth">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">
        {{ currentData.title }}
        <p
          v-if="currentData.availableFromSecondRound && !isAfterFirstRound"
          style="margin-bottom: 0"
        >
          <i>Available from the second round</i>
        </p>
      </div>
    </div>

    <div class="tabulka__body">
      <table>
        <thead>
          <td
            v-for="purchaseHead in currentData.header"
            :key="purchaseHead.title"
          >
            <span> {{ purchaseHead.title }} </span>
          </td>
        </thead>
        <tr v-for="purchase in currentData.products" :key="purchase.title">
          <td v-if="purchase.title != ''">
            {{ purchase.title }}
          </td>
          <td v-for="buttons in purchase.variants" :key="buttons.title">
            <button
              class="button noFloat"
              :disabled="
                !isAffordable(buttons.price) ||
                (currentData.availableFromSecondRound && !isAfterFirstRound)
              "
              @click="openModalQuestion(buttons)"
            >
              Buy for {{ buttons.price }} €
            </button>
            <small
              v-if="!isAffordable(buttons.price)"
              class="validate-warn"
              style="margin-left: 10px"
              >(Low budget)</small
            >
          </td>
        </tr>
      </table>
    </div>

    <Modal ref="modalRef" width="450px">
      <div class="modal__questionHeader">
        <p>Do you really want to buy:</p>
        <p>
          <small>
            {{ currentData.title }}
            <br />{{ modalProduct }}
          </small>
        </p>
      </div>
      <div class="clearfix">
        <button class="modal__approve" @click="buyData()">
          Buy for {{ price }} €
        </button>
        <div class="modal__cancel" @click="closeModal()">No</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "@/components/general/Modal.vue";
import ModalJs from "@/components/general/ModalJs.js";

import { mapActions } from "vuex";

export default {
  name: "DataProductTable",
  mixins: [ModalJs],
  components: {
    Modal,
  },
  props: {
    TableWidth: String,
    typeTable: String,
  },
  data: function () {
    return {
      price: 0,
      type: "",
      modalProduct: "",
      productsData: {
        quantitative: {
          title: "Demand (quantitative)",
          availableFromSecondRound: true,
          products: [
            {
              title: "My products",
              availableFromSecondRound: true,
              variants: [
                {
                  title: "Demand (quantitative) My products - 50 respondents",
                  type: "DEMAND_QUANT_MY_PRODS_50",
                  price: 80,
                },
                {
                  title: "Demand (quantitative) My products - 100 respondents",
                  type: "DEMAND_QUANT_MY_PRODS_100",
                  price: 150,
                },
              ],
            },
            {
              title: "All products",
              availableFromSecondRound: true,
              variants: [
                {
                  title: "Demand (quantitative) All products - 50 respondents",
                  type: "DEMAND_QUANT_ALL_PRODS_50",
                  price: 140,
                },
                {
                  title: "Demand (quantitative) All products - 100 respondents",
                  type: "DEMAND_QUANT_ALL_PRODS_100",
                  price: 250,
                },
              ],
            },
          ],
          header: [
            {
              title: "",
            },
            {
              title: "50 respondents",
            },
            {
              title: "100 respondents",
            },
          ],
        },
        qualitative: {
          title: "Demand (qualitative)",
          availableFromSecondRound: true,
          products: [
            {
              title: "All products",
              variants: [
                {
                  title: "Demand (Qualitative) - 1 respondent",
                  type: "DEMAND_QUALITATIVE",
                  price: 40,
                },
              ],
            },
          ],
          header: [
            {
              title: "",
            },
            {
              title: "1 respondent",
            },
          ],
        },
        products: {
          title: "Sold products",
          availableFromSecondRound: true,
          products: [
            {
              title: "All products",
              variants: [
                {
                  title: "Sold products - All teams",
                  type: "SOLD_PRODUCTS",
                  price: 80,
                },
              ],
            },
          ],
          header: [
            {
              title: "",
            },
            {
              title: "All teams",
            },
          ],
        },
        demography: {
          title: "Demography",
          products: [
            {
              title: "",
              variants: [
                {
                  title: "Demography - 50 respondents",
                  type: "DEMOGRAPHY_50",
                  price: 60,
                },
                {
                  title: "Demography - 100 respondents",
                  type: "DEMOGRAPHY_100",
                  price: 110,
                },
              ],
            },
          ],
          header: [
            {
              title: "50 respondents",
            },
            {
              title: "100 respondents",
            },
          ],
        },
        effectivity: {
          title: "Mediatypes effectivity",
          availableFromSecondRound: true,
          products: [
            {
              title: "My Ads",
              availableFromSecondRound: true,
              variants: [
                {
                  title: "Mediatypes effectivity My ads - 50 ads",
                  type: "AD_TYPES_MY_50",
                  price: 80,
                },
                {
                  title: "Mediatypes effectivity My ads - 100 ads",
                  type: "AD_TYPES_MY_100",
                  price: 150,
                },
              ],
            },
            {
              title: "All ads",
              availableFromSecondRound: true,
              variants: [
                {
                  title: "Mediatypes effectivity All ads - 50 ads",
                  type: "AD_TYPES_ALL_50",
                  price: 140,
                },
                {
                  title: "Mediatypes effectivity All ads - 100 ads",
                  type: "AD_TYPES_ALL_100",
                  price: 250,
                },
              ],
            },
          ],
          header: [
            {
              title: "",
            },
            {
              title: "50 ads",
            },
            {
              title: "100 ads",
            },
          ],
        },
      },
    };
  },
  computed: {
    ...mapGetters(["activeGame", "gameTeam"]),
    isAfterFirstRound() {
      return this.activeGame && this.activeGame.turn > 1;
    },
    currentData() {
      return this.productsData[this.typeTable];
    },
  },
  methods: {
    ...mapActions(["purchaseData", "toggleLoader"]),
    isAffordable(price) {
      return this.gameTeam && this.gameTeam.money >= price;
    },
    openModalQuestion({ type, price, title }) {
      this.price = price;
      this.type = type;
      this.modalProduct = title;
      this.openModal();
    },
    async buyData() {
      await this.toggleLoader(true);
      await this.purchaseData({ type: this.type, title: this.modalProduct });
      this.closeModal();
      await this.toggleLoader(false);
    },
  },
};
</script>
 